import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatiPignoramentoFormComponent } from 'src/app/common/form/dati-pignoramento-form.component';
import { DatiPignoramento } from 'src/app/common/models/dati-pignoramento/dati-pignoramento';
import { DatiPignoramentoResponse } from 'src/app/common/models/dto/dati-pignoramento-response';
import { SezioneDatiPignoramento } from 'src/app/common/models/sezioni/sezione-dati-pignoramento';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [dati-pignoramento-form-update]',
  templateUrl: '../../../form/dati-pignoramento-form.html'
})
export class DatiPignoramentoUpdateComponent extends DatiPignoramentoFormComponent implements OnInit {
  urlUpdateBene: string;
  idSezione: string;
  datiPignoramento: DatiPignoramento;

  @Output()
    onReturn: EventEmitter<SezioneDatiPignoramento> = new EventEmitter<SezioneDatiPignoramento>();

  constructor(@Inject(OperationsService) operationService: OperationsService,
              @Inject(FormBuilder) campiForm,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(FormValidationService) formValidationService: FormValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica dati pignoramento');
    this.isInserimento(false);
  }

  getDatiPignoramento(): DatiPignoramento {
    return this.datiPignoramento;
  }

  getRequest(datiPignoramento: DatiPignoramento) {
    this.operationService.updateDatiPignoramento(this.urlUpdateBene, this.idSezione, datiPignoramento).subscribe(response => this.datiPignoramentoUpdated(response));
  }

  datiPignoramentoUpdated(response: DatiPignoramentoResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(datiPignoramento: DatiPignoramento, urlUpdateBene: string, idSezione: string) {
    this.datiPignoramento = datiPignoramento;
    this.urlUpdateBene = urlUpdateBene;
    this.idSezione = idSezione;
    this.createForm();
  }
}
